import { StepperItem } from '../Page/PageTypes';
import styles from './FormSideStepper.module.scss';
import clsx from 'clsx';

type FormSideStepperProps = {
    stepperConfig: StepperItem[];
    step: number;
    isFormValid: boolean;
    onStepChange: (stepIndex: number) => void;
};

const FormSideStepper = ({ stepperConfig, step, isFormValid, onStepChange }: FormSideStepperProps) => {
    return (
        <div className={styles.FormStepperWrapper}>
            <div className={styles.StepperContainer}>
                {stepperConfig.map((item, index) => (
                    <div
                        onClick={() => isFormValid && onStepChange(index)}
                        key={index}
                        className={clsx({
                            [styles.StepperItem]: true,
                            [styles.StepperItemActive]: step === index,
                            [styles.StepperItemDisabled]: !isFormValid,
                        })}
                    >
                        <div className={styles.StepperText}>
                            {index + 1}. {item.text}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default FormSideStepper;
